import renderElement from './element';

export default renderElement.bind(null, 'button');




// WEBPACK FOOTER //
// ../~/idom-util/src/button.js